const createIDedSelector = (id: string | number, prefix: string) =>
  `${prefix}${String(id)}`;

export const generalTestIDs = {
  lang: {
    dropdownContainer: 'e2e_general-lang-dropdown',
    lang: (lang: string) =>
      createIDedSelector(String(lang), 'e2e_general-lang-'),
  },
  sideMenu: {
    dashboard: 'e2e_general-side-menu-dashboard',
    myLink: 'e2e_general-side-menu-my-link',
    myURLs: 'e2e_general-side-menu-my-urls',
    myQRs: 'e2e_general-side-menu-my-qr-codes',
    analytics: 'e2e_general-side-menu-analytics',
  },
};
